import * as React from 'react';
import * as elog from '@reverbdotcom/commons/dist/elog';
import { MutationFn, compose } from 'react-apollo';
import { trackView, IEventData } from '@reverbdotcom/commons/dist/tracker';
import {
  BillingMethodChallengeShopper,
  BillingMethodIdentifyShopper,
  core_apimessages_Error,
} from '../schemas/rql';
import ThreeDS2Interaction from '../credit_cards/threeds2/threeds2_interaction';
import { connectBillingMethodChallengeShopper, connectBillingMethodIdentifyShopper } from './threeds2_billing_operations';
import bind from '@reverbdotcom/commons/dist/bind';
import { parseGraphqlErrors } from '@reverbdotcom/commons/dist/parse_graphql_errors';
import { BillingMethodResult } from './billing_method_result';
import LoadingBars from '../components/loading_bars';

interface ExternalProps {
  billingMethodResult: BillingMethodResult;
  title?: string;
  onError(errors: core_apimessages_Error[]): void;
  onBillingMethodResult(billingMethodResult: BillingMethodResult): void;
}

interface ApolloProps {
  identifyShopper: MutationFn<BillingMethodIdentifyShopper.Mutation, BillingMethodIdentifyShopper.Variables>;
  challengeShopper: MutationFn<BillingMethodChallengeShopper.Mutation, BillingMethodChallengeShopper.Variables>;
}

type Props = ExternalProps & ApolloProps;

function BillingTitle({ title }: { title: string }) {
  if (!title) {
    return null;
  }

  return (
    <div className="form-section-wrapper__header">
      <h2 className="form-section-wrapper__title">
        {title}
      </h2>
    </div>
  );
}

const TAG = 'adyen.threeds2_billing_container';

export class ThreeDS2BillingContainer extends React.Component<Props> {

  get paymentStatus() {
    return this.props.billingMethodResult.adyenPaymentResult.paymentStatus;
  }

  eventData(additionalContext = {}): IEventData {
    return {
      componentName: 'ThreeDS2BillingContainer',
      context: {
        ...additionalContext,
        props: { ...this.props },
      },
    };
  }

  componentDidMount() {
    trackView(this.eventData());
    elog.info(`${TAG}.mount`, { ...this.eventData() });
  }

  @bind
  async onIdentifyShopperComplete(fingerprintResult: string) {
    try {
      const result = await this.props.identifyShopper({ variables: { input: {
        billingMethodUuid: this.props.billingMethodResult.billingMethodUuid,
        results: {
          paymentData: this.props.billingMethodResult.adyenPaymentResult.paymentData,
          threeds2FingerprintResult: fingerprintResult,
        },
      } } });

      if (result) {
        this.props.onBillingMethodResult(result.data.billingMethodIdentifyShopper);
      }
    } catch (error) {
      this.onThreeDSFailed(parseGraphqlErrors(error));
    }
  }

  @bind
  async onChallengeShopperComplete(challengeResult: string) {
    try {
      const result = await this.props.challengeShopper({ variables: { input: {
        billingMethodUuid: this.props.billingMethodResult.billingMethodUuid,
        results: {
          paymentData: this.props.billingMethodResult.adyenPaymentResult.paymentData,
          threeds2ChallengeResult: challengeResult,
        },
      } } });
      if (result) {
        this.props.onBillingMethodResult(result.data.billingMethodChallengeShopper);
      }
    } catch (error) {
      this.onThreeDSFailed(parseGraphqlErrors(error));
    }
  }

  onThreeDSFailed(errors: core_apimessages_Error[]) {
    elog.info(`${TAG}.failed`, {
      errors,
      paymentStatus: this.paymentStatus,
    });
    this.props.onError(errors);
  }

  render() {
    return (
      <div>
        <BillingTitle title={this.props.title} />
        <div className="bg-white padding-4">
          <div className="d-flex fx-justify-center mtb-1">
            <LoadingBars />
          </div>
          <ThreeDS2Interaction
            challengeToken={this.props.billingMethodResult.adyenPaymentResult.challengeToken}
            fingerprintToken={this.props.billingMethodResult.adyenPaymentResult.fingerprintToken}
            onChallengeShopperComplete={this.onChallengeShopperComplete}
            onIdentifyShopperComplete={this.onIdentifyShopperComplete}
            paymentStatus={this.paymentStatus}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  connectBillingMethodIdentifyShopper,
  connectBillingMethodChallengeShopper,
)(ThreeDS2BillingContainer) as React.ComponentClass<ExternalProps>;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/billing/threeds2_billing_container.tsx